/**
 * This file handles the image paths
 */

import {gsap} from 'gsap';
import {MorphSVGPlugin} from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(MorphSVGPlugin);

( function() {

	const blobPaths = [

		'M685.6558,84.3816c84.99,20.694,190.89,29.06,248.2249,65.1643s64.7543,99.948,64.08,163.7915-10.1179,127.6868-57.3346,174.7989C894.0837,535.6886,809.0937,566.95,724.1037,596.01c-84.3155,29.5-167.9565,57.2389-244.8523,49.7538-76.8957-7.9254-147.0462-50.6344-231.3617-80.1345-83.641-29.5-181.447-45.7911-221.2439-85.4181-40.4714-40.0673-22.9338-103.03-14.84-163.3511S17.877,199.3,46.8815,146.4638c28.33-52.3956,87.6882-99.948,163.9094-124.1645,75.5467-24.2164,168.631-24.2164,246.8758-7.9254C536.586,30.665,599.9912,63.6875,685.6558,84.3816Z',

		'M762.71,6.43C814.05,22.51,823.86,99.78,868.85,161S994,267.72,996.92,314.62c2.88,46.46-71.53,94.7-136.72,129.54-64.61,34.39-120,56.28-173.64,88.88C632.91,566.09,581,609.87,512.92,631.31c-67.5,21.44-151.72,20.54-231.91-.45-80.76-21-158.06-61.19-210-117.47C18.54,457.11-8.58,385.2,5.84,320c15-65.65,71-124.61,127.49-175.53,56-50.92,111.92-93.8,177.68-103.18,66.34-9.38,141.91,15.18,226.14,4.91C620.8,35.46,711.94-9.65,762.71,6.43Z',

		'M696.14,75.94c87,31.8,182.36,57.33,236.48,104.81,54.13,47.92,67.66,117.79,65.08,186.77S977.08,504.12,915.87,544C855.3,583.4,751.56,594.59,666.5,609.82c-84.41,14.78-150.13,34-218.44,36.73-67.65,3.13-137.89-10.3-210.06-30.91-72.17-20.15-145.62-47-175.26-89.57C33.1,484,47.27,426.19,35.67,363.48,23.43,301.23-13.94,234.05,8.61,183s105-86.44,188.8-119.59C280.53,30.26,365.59-1.09,448.06,2.49,529.9,5.63,609.15,44.14,696.14,75.94Z',

		'M989.76,337.72c17.34,68.45-.88,144.45-62.08,187.89S762.33,580,679.85,599.44s-142.4,47.74-200.65,45.43c-58.59-2.73-115.51-36-184.9-57.93C224.57,564.61,142.7,554.06,106,517.27c-36.37-36.38-28.09-98.75-49.9-169.09C33.77,278.11-20.4,199.75,12.16,160.44,44.4,120.72,163,119.62,249.79,93.37c87-26.93,141.13-79.18,203.32-88.72S585,28.56,654.89,59.54c70.46,30.72,141.52,59.4,202.91,103.9C919.51,208.36,972.42,269.27,989.76,337.72Z',

		'M657.79,97.26c65.67,32.7,136.49,51.45,197,86.77,61.17,34.88,111.39,86.33,132,145.2,20,59.3,11,126.44-29.62,184.87-41.2,58-114,106.83-200.23,124.27-85.63,17.44-184.78,3.49-282,.87-96.58-2.61-191.22,6.54-262-17C142.08,599.13,96.36,542.88,77.05,487.5,57.73,431.69,66.1,376.75,47.43,314,28.76,251.61-16.31,181.85,10.09,135.2S135.64,65,224.49,41.45C314,17.9,393.17-5.64,463.35,6.13,532.89,17.47,592.76,64.12,657.79,97.26Z',

		'M685.61,85.4c84.73,20.62,190.31,28.95,247.47,64.93s64.55,99.59,63.88,163.2S986.87,440.76,939.8,487.7c-46.4,47.39-131.13,78.54-215.86,107.49-84.06,29.4-167.45,57-244.11,49.58-76.66-7.9-146.6-50.46-230.65-79.85-83.39-29.39-180.9-45.63-220.57-85.11C-11.74,439.88,5.74,377.15,13.81,317s6-117.14,35-169.78C77,95.05,136.2,47.67,212.19,23.54,287.51-.59,380.31-.59,458.31,15.64,537,31.87,600.2,64.78,685.61,85.4Z',

		'M687.48,93.55C744,115.44,793.66,151.61,847.32,196.82s110.8,99,135.61,164.67c25.39,65.67,17.89,143.25-34.62,189.89s-150,62.82-231.4,63.77c-81.36,1.43-147.15-11.9-218.7-2.86-71.56,8.57-149.46,40-223.9,35.22s-145.42-45.21-195-100.42C29.64,491.41.79,420.5,3.1,351,6,281.06,40,213,82.73,147.33,126,82.13,177.94,19.78,249.5,5,321.63-9.72,412.8,23.59,490.13,43.58,567.45,64,630.93,71.66,687.48,93.55Z',

		'M587.08,59.1c78,15.24,174.63,23.88,255.95,62,80.65,38.11,146,106.72,154,178.37,8.66,72.17-40,147.38-98.65,215C839,581.52,769,640.47,683.06,645.55c-86,5.59-187.3-42.69-281.28-53.36C307.8,582,221.15,610,149.17,598.8,76.52,587.62,17.86,537.31,4.53,480.39c-14-56.92,16.66-120.95,38.66-174.82s35.33-98.59,54-148.39c19.33-49.8,44-105.7,94.65-133.15C242.48-2.9,317.8-1.88,385.12,9.8,451.77,21.49,509.76,43.85,587.08,59.1Z'

	];

	const imageBlobs = document.getElementsByClassName('rect');
	const switchToggle = document.getElementById('toggle-switch');

	if(imageBlobs.length && switchToggle) {

		MorphSVGPlugin.convertToPath('rect');

		const tl = gsap.timeline({paused: true});
		const tl2 = gsap.timeline({paused: true});
		const tl3 = gsap.timeline({paused: true});

		const ease = 'elastic.inOut(0.8, 0.2)';
		const duration = 2;

		tl.to('.blob-image-wrapper', {
			scale: 1.1,
			duration,
			rotate: gsap.utils.random(-3, 3),
			ease
		}, 0);

		Array.from(imageBlobs).forEach((path) => {

			tl.to(path, {
				duration,
				ease,
				morphSVG: blobPaths[blobPaths.length * Math.random() | 0]
			}, 0);

			tl2.to(path, {
				scaleX: gsap.utils.random(0.85, 0.98),
				rotate: gsap.utils.random(-6, 6),
				scaleY: gsap.utils.random(0.85, 0.98),
				repeat: -1,
				yoyo: true,
				duration: gsap.utils.random(4, 6),
				ease: 'sine.inOut'
			}, 0);

			tl3.to(path, {
				scaleX: 1,
				rotate: 0,
				scaleY: 1,
				ease: 'sine.inOut',
				duration: 1
			}, 0);

		});

		switchToggle.addEventListener('change', (e) => {

			if(e.currentTarget.checked) {
				tl3.pause();
				tl.play();
				tl2.play();
			} else {
				tl2.pause();
				tl.reverse();
				tl3.play();
				tl2.seek(0);
			}

		});

	}

}() );
